/* Implements the "Show More" button on search results. */
stimulusApp.register(
  "offers-search-results",
  class extends Stimulus.Controller {
    static targets = ["button", "content", "frame"]

    connect() {
      this.observer = new IntersectionObserver(this.startLoading.bind(this), {
        rootMargin: "0px 0px 3000px 0px",
      })
      this.observer.observe(this.buttonTarget)
    }

    disconnect() {
      this.observer.disconnect()
    }

    startLoading(entries) {
      if (entries[0].isIntersecting && this.hasFrameTarget) {
        this.frameTarget.setAttribute("loading", "eager")
      }
    }

    show() {
      this.buttonTarget.remove()
      HB.unwrapElement(this.contentTarget)
      HB.unwrapElement(this.element)
    }
  },
)
